import React from "react";
import {Row, Button, Spinner} from "react-bootstrap";
import './PageFooter.css';


class PageFooter extends React.Component {

  // Keep this constructor so that the props are passed to the super.
  // Do not be tempted to remove it despite the warning.
  constructor(props) {
    super(props);
  }
  
  /**
   * Dedicated prev page button handler that helps support dynamic changes in the previous page target.
   */
  prevPageBtnClicked = () => {
    this.props.updatePrevPage();
  };
  
  /**
   * Dedicated next page button handler that helps support dynamic changes in the next page target.
   */
  nextPageBtnClicked = async () => {
    await this.props.updateNextPage();
  };
  
  footerStyle = {
    position: 'absolute',
    bottom: 0,
    width: '100%',
    textAlign: 'center',
    paddingBottom: '1em'
  };
  
  render() {
    let col = (this.props.prevPage && this.props.nextPage) ? "col-6" : "col-12";

    return (
        <Row className={"page-footer"}>
          {
            this.props.prevPage && (
                <div id={'prevBtnContainer'} className={col + " text-center"}>
                  <Button id={'prevBtn'} variant={'primary'} className={'nsre-button'} disabled={this.props.prevBusy}
                          style={{minWidth: '109px', backgroundColor: '#6c757d', borderColor: '#6c757d'}}
                          onClick={() => this.prevPageBtnClicked()}>
                    {
                      this.props.prevBusy ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          />
                      ) : (
                          <span>{this.props.prevLabel}</span>
                      )
                    }
                  </Button>
                </div>
            )
          }
          {
            this.props.nextPage && (
                <div id={'nextBtnContainer'} className={col + " text-center"}>
                  <Button id={'nextBtn'} variant={'primary'} className={'nsre-button'} disabled={this.props.nextBusy}
                          style={{minWidth: '109px'}}
                          onClick={() => this.nextPageBtnClicked()}>
                    {
                      this.props.nextBusy ? (
                        <Spinner
                          as="span"
                          animation="border"
                          size="sm"
                          role="status"
                          aria-hidden="true"
                          />
                      ) : (
                          <span>{this.props.nextLabel}</span>
                      )
                    }
                  </Button>
                </div>
            )
          }
        </Row>
    );
  }
}

export default PageFooter;